import { render, staticRenderFns } from "./staking.vue?vue&type=template&id=3603320b&scoped=true&"
var script = {}
import style0 from "./staking.vue?vue&type=style&index=0&id=3603320b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603320b",
  null
  
)

export default component.exports